<template>
  <div class="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->    
    <Login v-if="!isLoggedIn"/>
  <div>Welcome to solar tester web site!</div>
  </div>
</template>

<script>
// @ is an alias to /src
import Login from '@/components/Login.vue'

export default {
  name: 'Home',
  data() {
    return {
      isLoggedIn: false
    }
  },
  components: {
    Login
  },
  async created () {
      if(this.$store.state.accessToken){          
        //this.$router.push({name:"Tester"});
        this.isLoggedIn = true;
      }      
  }
}
</script>
